<svelte:options runes={true} />

<script lang="ts">
  import IconX from "~icons/dusk/x";
  import type { Snippet } from "svelte";

  interface Props {
    onClose?: () => void;
    children?: Snippet;
    closeButton?: Snippet;
    class?: string;
  }

  let { onClose, children, closeButton, class: className = "" }: Props = $props();
</script>

{#snippet defaultCloseButton()}
  <button
    type="button"
    class="da-slide-over-dialog-header__close"
    onclick={onClose}
    aria-label="Close"
  >
    <IconX aria-hidden="true" width="24" height="24" />
  </button>
{/snippet}

<div class="da-slide-over-dialog-header {className}">
  {#if children}{@render children()}{/if}
  {@render (closeButton ?? defaultCloseButton)()}
</div>

<style>
  @layer aurora {
    :global(.da-slide-over-dialog-header) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      width: calc(100% + var(--overlay-anim-overflow, 20%));
      left: calc((var(--overlay-anim-overflow, 20%) / 2) * -1);
      padding-block: var(--da-space-4);
      padding-inline: calc(var(--overlay-anim-overflow, 20%) - var(--da-space-4));
      background: var(--da-color-brand-sand-500);
      flex-shrink: 0;
    }

    :global(.da-slide-over-dialog-header__close) {
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--da-color-charcoal-500);
      background: none;
      border: none;
      cursor: pointer;
      transition: opacity 0.15s;
    }

    :global(.da-slide-over-dialog-header__close:hover) {
      opacity: 0.7;
    }

    :global(.da-slide-over-dialog-header__close:focus-visible) {
      outline: 2px solid var(--da-color-charcoal-500);
      outline-offset: 2px;
    }
  }
</style>
